

export const OFFICE_DOMAIN = 'https://lofty.com'



